import proj4 from 'proj4';

// This is necessary because the highcharts map module does not support latitude / longitudes without this being introduced first.
// This may caused issues if we move to an SSR model.

if (typeof window !== 'undefined') {
  window.proj4 = window.proj4 || proj4;
}

export default proj4;